import React, { PureComponent } from 'react'
import animateScrollTo from 'animated-scroll-to'
import each from 'lodash/forEach'

import './legal-layout.styl'

type Props = {
  template: { html: string }
  locale: string
  subItem?: string
}

const SCROLL_SPEED = 420

export default class LegalLayout extends PureComponent<Props> {
  node: HTMLElement | null | undefined

  componentDidMount(): void {
    this.addEvents()

    const { subItem } = this.props
    const matchingParagraphNode = document.getElementById(subItem as string)

    if (matchingParagraphNode) {
      const bodyTop =
        (document.body && document.body.getBoundingClientRect().top) || 0
      const nodeTop = matchingParagraphNode.getBoundingClientRect().top
      animateScrollTo(nodeTop - bodyTop, { speed: SCROLL_SPEED })
    }
  }

  componentDidUpdate({
    template,
    locale,
  }: {
    template: { html: string }
    locale: string
  }): void {
    const hasTemplateLoaded = !template.html && this.props.template.html
    const hasLocaleChanged = locale && locale !== this.props.locale

    if (hasTemplateLoaded || hasLocaleChanged) {
      this.resetEvents()
      this.addEvents()
    }
  }

  componentWillUnmount(): void {
    this.resetEvents()
  }

  resetEvents = (): void => {
    each(this.findNavLinks(), link =>
      link.removeEventListener('click', this.handleNavigation),
    )

    window.removeEventListener('scroll', this.handleScroll)
  }

  addEvents = (): void => {
    const { locale } = this.props

    each(this.findNavLinks(), link =>
      link.addEventListener('click', this.handleNavigation),
    )

    if (locale === 'ru') {
      window.addEventListener('scroll', this.handleScroll)
    }
  }

  findNavLinks = () => {
    if (!this.node) return

    return this.node.querySelectorAll('.js-nav-link')
  }

  findCorrespondingTextNode = (link: HTMLAnchorElement): Element | null => {
    const id = link.href?.split('#').pop()

    if (this.node && this.node instanceof HTMLElement) {
      return this.node.querySelector(`#${id}`)
    }
    return null
  }

  handleNavigation = (evt: Event): void => {
    evt.preventDefault()

    const node =
      evt.target instanceof HTMLAnchorElement &&
      this.findCorrespondingTextNode(evt.target)

    if (node && node instanceof HTMLElement) {
      const bodyTop =
        (document.body && document.body.getBoundingClientRect().top) || 0
      const nodeTop = node.getBoundingClientRect().top

      if (window) {
        window.history.pushState('', '', `/about/legal/${node.id}`)
      }

      animateScrollTo(nodeTop - bodyTop, { speed: SCROLL_SPEED })
    }
  }

  handleScroll = (): void => {
    window.requestAnimationFrame(() => {
      each(this.findNavLinks(), link => {
        const node = this.findCorrespondingTextNode(link as HTMLAnchorElement)
        const rect = node && node.getBoundingClientRect()
        const currentClass = 'ru-legal-layout__nav-link_current'

        if (rect && rect.top <= 1 && rect.bottom > 0) {
          link.classList.add(currentClass)
          window.history.pushState('', '', `/about/legal/${node.id}`)
        } else {
          link.classList.remove(currentClass)
        }
      })
    })
  }

  render(): JSX.Element {
    const {
      template: { html = '' },
    } = this.props

    return (
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        ref={node => (this.node = node)}
      />
    )
  }
}
